import React, { useContext, useEffect, useState } from "react";
import Loader from "../../components/Loader";
import { ERROR, GET, INFO, MEDIUM, ROWS_PER_PAGE } from "../../utils/constants";
import { Grid, Typography } from "@mui/material";
import {
  IFailedOrderLog,
  IFailedOrderLogsFilters,
} from "../../interfaces/order";
import { fetchData } from "../../utils/dataProvider";
import { IAlert } from "../../interfaces/alert";
import SearchInput from "../../components/SearchInput";
import ListFailedOrderLogs from "../../components/tables/ListFailedOrderLogs";
import GenericAlert from "../../components/GenericAlert";
import { UserContext } from "../../contexts/userContext";
import { IPaginationParams } from "../../interfaces/table";

const Filters = ({ getFailedOrderLogs }: IFailedOrderLogsFilters) => {
  const [searchValue, setSearchValue] = useState<string>("");
  const [activeSearch, setActiveSearch] = useState<boolean>(false);
  const handleChange = (query: string) => {
    setSearchValue(query);
    setActiveSearch(false);
  };
  const handleClose = async () => {
    setSearchValue("");
    await getFailedOrderLogs();
    setActiveSearch(false);
  };
  const handleSubmit = async () => {
    if (!searchValue) return;
    await getFailedOrderLogs(searchValue);
    setActiveSearch(true);
  };

  return (
    <>
      <Grid item xs={12} md={6}>
        <SearchInput
          {...{
            searchValue,
            setSearchValue,
            handleChange,
            handleClose,
            handleSubmit,
            activeSearch,
          }}
          placeholder="Buscar por id externo de la orden"
        />
      </Grid>
    </>
  );
};

const FailedOrderLogs = () => {
  const { currentUser } = useContext(UserContext);
  const [failedOrderLogs, setFailedOrderLogs] = useState<IFailedOrderLog[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [alert, setAlert] = useState<IAlert>({} as IAlert);
  const [pagination, setPagination] = useState({
    count: 0,
    page: 0,
  } as IPaginationParams);
  const getFailedOrderLogs = async (
    external_id?: string,
    newPage = 0 as number
  ) => {
    setLoading(true);
    try {
      const skip = newPage * ROWS_PER_PAGE;
      const { fetchedFailedOrderLogs, count } = await fetchData({
        url: `orders/audit/failedOrderLogs?limit=${ROWS_PER_PAGE}&skip=${skip}${
          external_id ? `&externalId=${external_id}` : ""
        }${currentUser.clientId ? `&clientId=${currentUser.clientId}` : ""}`,
        method: GET,
      });
      setFailedOrderLogs(fetchedFailedOrderLogs);
      setPagination({ count, page: newPage });
      const newAlert =
        fetchedFailedOrderLogs.length > 0
          ? {}
          : {
            typeOfAlert: INFO,
            message: "No hay órdenes para mostrar.",
            showAlert: true,
          };
      setAlert(newAlert as IAlert);
    } catch (error: any) {
      setAlert({
        typeOfAlert: ERROR,
        message: error?.message || error,
        showAlert: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage: number) =>
    getFailedOrderLogs(undefined, newPage);

  useEffect(() => {
    getFailedOrderLogs();
  }, []);

  return (
    <Grid container>
      <Grid item xs={12} mt={5} mb={5}>
        <Typography className="f-s-20">Logs de órdenes fallidas</Typography>
      </Grid>
      <Grid container item xs={12} md={8} xl={6} spacing={2}>
        <Filters {...{ getFailedOrderLogs }} />
      </Grid>
      <Grid container>
        {alert.showAlert && !loading && (
          <Grid item xs={12} mt={2}>
            <GenericAlert {...{ alert }} />
          </Grid>
        )}
        {(!alert.showAlert || loading) && (
          <Grid item xs={12}>
            {loading ? (
              <Loader size={MEDIUM} />
            ) : (
              <ListFailedOrderLogs
                {...{ failedOrderLogs, pagination, handlePageChange }}
              />
            )}
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default FailedOrderLogs;
